import { SimulationYamadumiAutoRes } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 労務山積計算-自動山積結果取得API
 */
export class YamadumiAutoGateway {
  static getYamadumiAutoList = async (
    simulationYm: string,
    procurementNo: string,
    subNo: string,
    branchCd: string,
    expense: string,
    expenseSeq: string,
    displayStartYear: string
  ) => {
    return await yamadumiApi.get<SimulationYamadumiAutoRes>(
      '/api/simulation/yamadumi-auto',
      { simulationYm, procurementNo, subNo, branchCd, expense, expenseSeq, displayStartYear }
    )
  }
}
